// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import MaskedInput from "../MaskedInput";
import { noop } from "../util";
import phoneUtils from "../util/phoneUtil";

const options = {
  MOBILE: {
    mask: "(99) 99999-9999",
    errorMessage: "Número inválido. Digite o seu DDD seguido dos 9 dígitos",
    requiredMessage: "Campo obrigatório. Digite seu número de celular",
    label: "Celular",
  },
  FIXED_LINE: {
    mask: "(99) 9999-9999",
    errorMessage: "Número inválido. Digite o seu DDD seguido dos 8 dígitos",
    requiredMessage: "Campo obrigatório. Digite seu número de telefone",
    label: "Telefone",
  },
};

function PhoneInput({
  value,
  onChange,
  phoneType,
  onValidityChange,
  ...props
}) {
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState(false);
  const [empty, setEmpty] = useState(true);

  const helperText = empty
    ? options[phoneType].requiredMessage
    : options[phoneType].errorMessage;

  useEffect(() => {
    const phone = phoneUtils.parsePhoneNumber(value);
    const isValid =
      phoneUtils.isValid(phone) && phoneUtils.isOfType(phoneType, phone);
    setError(!isValid);
    setEmpty(value.length === 0);
    onValidityChange(isValid);
  }, [onValidityChange, phoneType, value]);

  return (
    <MaskedInput
      value={value}
      label={options[phoneType].label}
      mask={options[phoneType].mask}
      onChange={onChange}
      onBlur={() => setTouched(true)}
      error={touched && error}
      placeholder="(00) 00000-0000"
      helperText={touched && error ? helperText : ""}
      type="tel"
      inputProps={{ inputMode: "tel" }}
      autoComplete="tel-national"
      {...props}
    />
  );
}

PhoneInput.defaultProps = {
  onValidityChange: noop,
};

PhoneInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onValidityChange: PropTypes.func,
  phoneType: PropTypes.oneOf(["MOBILE", "FIXED_LINE"]).isRequired,
};

export default PhoneInput;
